import React, { createContext, useContext, useState } from 'react';

export type PaymentSelectionState = {
  expanded: boolean;
  tabValue: TabValue;
  creditCardError: string;
  paymentCardType: string;
  setExpanded: (value: boolean) => void;
  setCreditCardError: (error: string) => void;
  setPaymentCardType: (type: string) => void;
  setTabValue: (value: TabValue) => void;
};

export enum TabValue {
  offline = 'Offline',
  online = 'Online',
}

const PaymentSelectionContext = createContext<PaymentSelectionState | undefined>(undefined);

export const usePaymentSelectionContext = (): PaymentSelectionState => {
  const context = useContext(PaymentSelectionContext);
  if (!context) {
    throw new Error('usePaymentSelection must be used within a PaymentSelectionProvider');
  }
  return context;
};

type PaymentSelectionProviderProps = {
  children: React.ReactNode;
};

export const PaymentSelectionProvider: React.FC<PaymentSelectionProviderProps> = ({ children }) => {
  const [expanded, setExpanded] = useState(true);
  const [tabValue, setTabValue] = useState<TabValue>(TabValue.online);
  const [creditCardError, setCreditCardError] = useState('');
  const [paymentCardType, setPaymentCardType] = useState<string>('');

  const value = {
    tabValue,
    expanded,
    creditCardError,
    paymentCardType,
    setExpanded,
    setCreditCardError,
    setPaymentCardType,
    setTabValue,
  };

  return <PaymentSelectionContext.Provider value={value}>{children}</PaymentSelectionContext.Provider>;
};
